import FeaturesDefinition from "./features/FeaturesDefinition";
import Validators from "~/config/validation/validators/Validators";

export default Validators.shape({
    description: "Configuration root object",
    shape: {
        features: FeaturesDefinition,
    },
});
